import { render, staticRenderFns } from "./PieView.vue?vue&type=template&id=a1076c70&scoped=true"
import script from "./PieView.vue?vue&type=script&lang=js"
export * from "./PieView.vue?vue&type=script&lang=js"
import style0 from "./PieView.vue?vue&type=style&index=0&id=a1076c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1076c70",
  null
  
)

export default component.exports